import { MultimediaDisplay } from "Modules/Checkins/Overview/MultiMediaDisplay";

export const displayTitle = (type) => {
  if (type === "SURVEY") return "Survey";
  else if (type === "SKILLRATING") return "Skills rating";
  else if (type === "REQUESTFEEDBACK") return "Request feedback";
  else return "Learning check-in";
};

export const displayIcon = (type, checkinDetail) => {
  // if (["SURVEY", "SKILLRATING"].includes(type)) return <SurveyDetail />;
  // if (["SURVEY"].includes(type)) return <SurveyDetail />;
  // if (["SKILLRATING"].includes(type)) return <SRSDetail />;
  // if (
  //   ["REQUESTFEEDBACK"].includes(type) &&
  //   isEmpty(checkinDetail.multimediaCheckin)
  // )
  //   return <SurveyDetail />;
  if (["SURVEY"].includes(type))
    return <MultimediaDisplay checkinDetails={checkinDetail} />;
  else if (["SKILLRATING"].includes(type)) return null;
  else if (["REQUESTFEEDBACK"].includes(type))
    return <MultimediaDisplay checkinDetails={checkinDetail} />;
  // if (
  //   ["REQUESTFEEDBACK"].includes(type) &&
  //   isEmpty(checkinDetail.multimediaCheckin)
  // )
  //   return null;
  else return <MultimediaDisplay checkinDetails={checkinDetail} />;
};

export const coacheeLabel = (type) => {
  if (type === "SKILLRATING") return "Rated";
  else return "Assigned to";
};

export const coachLabel = (type) => {
  if (type === "SURVEY") return "Can view responses";
  else if (type === "SKILLRATING") return "Rater";
  else if (type === "REQUESTFEEDBACK") return "";
  else return "Can view & comment";
};
